import React from 'react';
import { useAuth } from  '../../contexts/auth';

import { createStore } from 'devextreme-aspnet-data';
import { formatNumber } from 'devextreme/localization';
import DataGrid, {
  Format,
  Column,
  Button,
  Pager,
  Paging,
  //FilterRow,
  HeaderFilter,
  Lookup,
  Popup,
  Form,
  Editing,
  Selection,
  Summary,
  Export,
  TotalItem,
  SearchPanel,
  Toolbar
  //Item
} from 'devextreme-react/data-grid';


import { Item} from 'devextreme-react/form';
import { useState, useEffect, useCallback} from "react";

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

export default function CompanyCostsTab(props) {

    const { user } = useAuth();
    
    const dataInizio = props.dataInizio
    const dataFine = props.dataFine
    const commessa = props.commessa

    const [categorie, setCategorie] = useState({});
    const [modalitaPagam, setModalitaPagam] = useState({});

    const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Movimento';
    const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Movimenti';

   
    const filterPayload = { 
        commessa: commessa,
        fromDate: dataInizio,
        toDate: dataFine
    };

    const remoteDataSource = createStore({
        key: 'id',
        loadUrl: serviceUrl2 + '/FindCostiGenerali',
      
        onBeforeSend: (method, ajaxOptions) => {
          if (method === "load" ) {           
              var payload = ajaxOptions.data;
              payload.values = JSON.stringify(filterPayload);
              ajaxOptions.data = payload;          
          }  
          ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
         ;
        },
        insertUrl: serviceUrl + '/InsertCostAction',
        updateUrl: serviceUrl + '/UpdateCostAction',
        deleteUrl: serviceUrl + '/DeleteAction'    
    });

    useEffect(() => {
  
        const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
        var newUrl5 =  newServiceUrl5 + "/GetAction";
    
        const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CategoriaAnalitica';
        var newUrl12 =  newServiceUrl12 + "/GetAction";

    
        const fetchData = async () => {
          try {
    
            const response5 = await fetch(newUrl5);
            const json5 = await response5.json();
            //console.log(json5);
            setModalitaPagam(json5);

            const response12 = await fetch(newUrl12);
            const json12 = await response12.json();
            //console.log(json12);
            setCategorie(json12);
    
          } catch (error) {
            console.log("error", error);
          }
        };
        fetchData();
      }, []);

    function onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('CostiGenerali');
    
        exportDataGrid({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Costi_Generali.xlsx');
          });
        });
        e.cancel = true;
    }

    const editorOptions = { readonly: true, format: '#,##0.00'};

    function onInitNewRow(e) {
        e.data.commessaId = commessa;
        e.data.dataRiferimento = new Date();
        e.data.importoTotale = 0;
        e.data.statoId = 0;
        e.data.tipoMovimentoId = 3;
        //aggiungere  setCellValue={setCellValue}

        // async function setAccountValues(newData, value, currentRowData) {
    
        //     return getCost(value,currentRowData.id).then(data => {
        //         newData.codicePagamento = value;
        // e.dataScadenza
        // e.importoParziale
        // e.importoRata
        // e.rata
    };

    function customizeData(data) {
        return `${formatNumber(data.value, '#,###,##0.00')}`;
    }

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <DataGrid
                        dataSource={remoteDataSource}
                        focusedRowEnabled={true}
                        showBorders={true}
                        onInitNewRow={onInitNewRow}
                        onExporting={onExporting}
                        dateSerializationFormat= {'yyyy-MM-dd'}
                        //onCellPrepared={onCellPreparedDue}
                        //onSelectionChanged={onRowSelectionChanged}
                        //onExporting={onExporting}
                        //onToolbarPreparing = {onToolbarPreparing}
                        //ref={ref => dueSupplierDataGridRef = ref}
                    >

                        <SearchPanel visible={true} width={240} placeholder="Cerca..." />
                        <HeaderFilter visible={true} />
                        <Selection mode="single" />

                        <Column dataField="id" caption="#" visible={true} width={80} />
                        <Column dataField="commessaId" visible={false} width={80} />
                        <Column dataField="dataRiferimento" dataType="date" format= {'dd/MM/yyyy'} visible={true} width={120}/>
                        <Column dataField="dataPagamento" caption="Data Pagamento" dataType="date" format= {'dd/MM/yyyy'} visible={true}/>
                       
                        <Column dataField="descrizione"  visible={true}/>
                        <Column dataField="tipoMovimentoId" caption="Tipo" visible={false}/>
                        <Column dataField="modalitaPagamentoId" caption="Modalità Pagamento" width={100} visible={false}>
                            <Lookup dataSource={modalitaPagam} displayExpr="descrizione" valueExpr="id" />
                        </Column>
                        <Column dataField="categoriaAnaliticaId" caption="Categoria" width={100} visible={false}>
                            <Lookup dataSource={categorie} displayExpr="descrizione" valueExpr="id" />
                        </Column>
                    
                        <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
                       
                        <Column dataField="importoTotale" visible={true} allowEditing={true} caption="Importo">
                            <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="statoId" visible={false} />
                        <Column dataField="tipoMovimentoId;" visible={false} />

                       
                        <Export enabled={true} allowExportSelectedData={false} />
          
        
                        <Editing
                            mode="popup"
                            useIcons={true}
                            allowAdding={true}
                            allowDeleting={true}
                            allowUpdating={true}     
                        >
                            <Popup   title= "&nbsp;&nbsp;&nbsp;Costo Generale " showTitle={true} width={800} height={625} />
                            
                            <Form>
                                <Item itemType="group" caption="" colCount={2} colSpan={2}>
                                
                                    <Item dataField="dataRiferimento" isRequired= "true"/>
                                    <Item dataField="importoTotale" editorOptions={editorOptions}/>
                                    <Item dataField="descrizione" colSpan={2} isRequired= "true"/>
                                    
                                    <Item dataField="dataPagamento" editorType="dxDateBox" /> 
                                    <Item dataField="modalitaPagamentoId" editorType="dxSelectBox" />  
                                    <Item dataField="riferimentoFattura"/>
                                    <Item dataField="categoriaAnaliticaId" editorType="dxSelectBox" />  
                                    <Item dataField="note" colSpan={2} editorType="dxTextArea" />
                                
                            
                                </Item> 
                            </Form>
                        </Editing>
                    </DataGrid>
                </div>
            </div>
        </React.Fragment>
    )
};